import angular from 'angular';
import gettext from 'angular-gettext';
import toastr from 'angular-toastr';
import PageResource from '../../cmsCore/PagesModules/PageResource';
import cmsPagesPreview from './Preview/Preview'
import deleteElementDialog from '../../cmsCore/DeleteElementModal/deleteElement';
import Context from "../../cmsCore/Creator/Context/Context";
import config from '../../cmsCore/ConfigModule/ConfigModule'
import historyStorage from '../../cmsCore/Creator/UndoRedo/historyStorage';
import cmsUndoRedo from '../../cmsCore/Creator/UndoRedo/undoRedo';
import saveGuard from "../../cmsCore/SaveGuard/SaveGuard";
import ImageSpinner from "../../cmsCore/Creator/ImageSpinner/ImageSpinner"
import tutorial from "./Tutorial/Tutorial";

let pagesFormPage = angular.module('cms.pages.add', [
        config,
        PageResource,
        gettext,
        toastr,
        cmsPagesPreview,
        deleteElementDialog,
        saveGuard,
        historyStorage,
        cmsUndoRedo,
        ImageSpinner,
        tutorial
    ]
).component('pagesFormPage', {
    template: require('./templates/pagesForm.html'),
    controller: function (
        $scope,
        PageResource,
        $state,
        $stateParams,
        $http,
        $q,
        toastr,
        gettextCatalog,
        ACLService,
        baSidebarService,
        deleteElementDialog,
        SaveWarning,
        SaveGuard,
        CONFIG,
        historyStorage,
        $element,
        tutorial,
        exportAsTemplateDialog
    ) {

        /** @ngInject */
        this.accordionsStatuses = {
            main: {
                isOpen: true
            },
            first: {
                isOpen: true,
                requiredKeys: ['title', 'slug', 'status'],
                hasErrors: false
            },
            second: {
                isOpen: false
            },
            third: {
                isOpen: false
            },
            fourth: {
                isOpen: false
            },
            fifth: {
                isOpen: false
            }
        };

        this.disablePageInfoAccordion = true;

        this.isElementSelected = () => {
            if (!this.creatorContext.hasCurrentElement()) {
                this.accordionsStatuses.main.isOpen = true;
                this.disablePageInfoAccordion = true;
                return true;
            }
            else {
                this.accordionsStatuses.main.isOpen = false;
                this.disablePageInfoAccordion = false;
                return false;
            }
        };


        this.$onInit = () => {
            this.creatorContext = new Context();
            this.creatorContext.setDragularScope($scope);
            historyStorage.register($element, () => this.page, $scope);


        };

        $scope.$on('history-storage-change', (event, snapshot) => {
            this.creatorContext.clearCurrentElement();
            this.page = snapshot.snapshot;
        });
        this.pageUrl = '';
        this.getPageUrl = (showToken = true) => {

            let getTokenString = () => {
                if(showToken && !this.letOpenPageWithoutToken) {
                    return '?token=' + btoa(this.page.slug + this.page.title + 'security-token');
                }
                return '';
            };

            return (typeof this.page.slug !== 'undefined') ? CONFIG.PUBLIC_SITE_URL.replace('__SITE_SLUG__', this.page.slug) + getTokenString() : this.pageUrl + getTokenString();
        };

        this.lineHeightUnits = [];

        PageResource.find({id: $stateParams.id},
            response => {
                this.page = response;
                this.pageUrl = CONFIG.PUBLIC_SITE_URL.replace('__SITE_SLUG__', this.page.slug);
                SaveWarning.watch(response, this.page, $scope, $element);
                historyStorage.add(this.page);
                this.letOpenPageWithoutToken = this.page.status === "public";
                $stateParams.pageTitle = this.page.title;

                tutorial.openIfFirstUsage();
            }
        );

        this.matchRoles = ACLService.matchRoles;
        if(this.matchRoles('ROLE_USER')) {
            $stateParams.returnState = {};
            $stateParams.returnState.name = 'dashboard';
        }

        this.errors = {};
        this.pending = false;

        this.statuses = [
            {
                value: 'public',
                label: gettextCatalog.getString('Public')
            },
            {
                value: 'draft',
                label: gettextCatalog.getString('Draft')
            }
        ];

        /**
         * Broadcast slug recalculation request
         */
        this.updateSlug = function () {
            if (!this.page.id || !this.page.slug) {
                $scope.$broadcast('slug.recalc');
            }
        };

        /**
         * Actions to validate slug
         * Returns promise;
         * @param data
         */
        this.validateSlug = function (data) {

            this.errors.slug = [];
            if (!data) {
                return $q.when([]);
            }

            let pageResourcePromise = PageResource.findAll({slug_strict: data}).$promise;

            pageResourcePromise.then((response) => {

                angular.forEach(response.data, function (value) {
                    if (value.id !== this.page.id) {
                        this.errors.slug = [gettextCatalog.getString('This value is already used')];
                    }
                    else {
                        this.errors.slug = null;
                    }
                }, this);
            });

            return pageResourcePromise;
        };

        this.onErrorMessage = function () {
            return toastr.error(
                gettextCatalog.getString('Please correct form errors and try again.', {title: this.page.title}),
                gettextCatalog.getString('Validation Errors')
            );
        };

        this.checkForErrors = () => {
            angular.forEach(Object.keys(this.accordionsStatuses), (accordionGroup) => {
                if (!this.accordionsStatuses[accordionGroup].requiredKeys) {
                    return;
                }
                let reqKeys = this.accordionsStatuses[accordionGroup].requiredKeys;
                let foundErrors = Object.keys(this.errors).filter((errorKey) => {
                    return reqKeys.indexOf(errorKey) !== -1 && this.errors[errorKey].length
                }).length > 0;

                if (foundErrors) {
                    this.accordionsStatuses[accordionGroup].hasErrors = true;
                    this.accordionsStatuses[accordionGroup].isOpen = true;
                    this.accordionsStatuses['main'].isOpen = true;
                } else {
                    this.accordionsStatuses[accordionGroup].hasErrors = false;
                }
            });
        };


        /**
         * Submit pages
         */
        this.update = async (redirect = true, clearHistory = true) => {

            this.pending = true;
            await SaveGuard.check();

            if (clearHistory) {
                historyStorage.clear();
            }

            return PageResource.update(this.page,
                response => {
                    this.errors = {};
                    SaveWarning.watch(response, this.page, $scope, $element);
                    toastr.success(
                        gettextCatalog.getString('Page {{title}} saved!', {title: this.page.title}),
                        gettextCatalog.getString('Success')
                    );
                    if (redirect) {
                        goToReturnState();
                    }
                    this.pending = false;
                    this.letOpenPageWithoutToken = this.page.status === "public";
                    this.checkForErrors();
                },
                response => {
                    if (response.status === 400) {
                        this.errors = response.data;
                        this.onErrorMessage();
                        this.checkForErrors();
                    }
                    this.pending = false;

                }
            ).$promise;
        };

        this.confirmDelete = () => {
            let removeMessage = gettextCatalog.getString("Are you sure that you want to delete this page?");
            deleteElementDialog.open(removeMessage).then(() => {
                this.delete();
            }).catch(() => {
            });
        };

        this.delete = () => {
            this.pending = true;
            PageResource
                .delete({id: this.page.id}, response => {
                    toastr.success(
                        gettextCatalog.getString('Page {{title}} deleted!', {title: this.page.title}),
                        gettextCatalog.getString('Success')
                    );
                    goToReturnState();
                    this.pending = false;
                })
        };

        this.cancel = () => goToReturnState();

        function goToReturnState() {
            SaveWarning.stopWatch();
            if ($stateParams.returnState) {
                $state.go($stateParams.returnState.name, $stateParams.returnState.params)
            } else {
                $state.go('pages', {})
            }
        }

        function collapseSidebar() {
            let startStatus = baSidebarService.isMenuCollapsed();
            baSidebarService.setMenuCollapsed(true);
            baSidebarService.lockAutoCollapse(true);
            $scope.$on('$destroy', () => {
                baSidebarService.lockAutoCollapse(false);
                baSidebarService.setMenuCollapsed(startStatus);
            });
        };

        collapseSidebar();

        $scope.$on('save.object', () => {
            this.update(false, false);
        });

        this.showTutorial = () => {
            tutorial.clearFirstUsage();
            tutorial.openIfFirstUsage();
        };

        this.exportAsTemplate = () => {
            exportAsTemplateDialog.open(this.page);
        };

    }
});

export default pagesFormPage.name;




// WEBPACK FOOTER //
// ./src/cmsPages/Pages/PagesFormPage.js